import { throwError as observableThrowError, Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ModalService {
    // public popup: Subject<any> = new Subject<any>();

    // constructor() {}

    public popup: Subject<any> = new Subject<any>();
    currentMessage = this.popup.asObservable();

    changeMessage(message: any): void {
        this.popup.next(message);
    }

}